import allRegionsImage from "../assets/programs/semua-wilayah.webp";
import indonesiaImage from "../assets/programs/indonesia.webp";
import middleEastImage from "../assets/programs/timur-tengah.webp";
import europeImage from "../assets/programs/eropa.webp";
import asiaPacificImage from "../assets/programs/asia-pasifik.webp";

// Konfirmasi cakupan negara dan ketentuan promo dengan klien sebelum rilis produksi.
export const allRegionsProgram = {
  id: "semua-wilayah",
  name: "Paket Semua Wilayah",
  shortName: "Semua Wilayah",
  audience: "Untuk yang masih membandingkan",
  description:
    "Perluas pilihan beasiswamu ke Indonesia, Asia Pasifik, Timur Tengah, dan Eropa. Bandingkan peluang, tentukan prioritas, lalu siapkan pendaftaran dengan lebih terarah.",
  scope: ["Indonesia", "Asia Pasifik", "Timur Tengah", "Eropa"],
  image: allRegionsImage,
  checkoutUrl: "https://goakal.com/pintarpilihkuliah/semua-wilayah/fz1nb/apply",
  coupon: {
    code: "diskon100semua",
    label: "Diskon Rp100.000",
  },
  coupons: [{ code: "diskon100semua", label: "Hemat Rp100.000" }],
};

export const regionalPrograms = [
  {
    id: "indonesia",
    name: "Program Mentoring Beasiswa Indonesia",
    shortName: "Indonesia",
    description:
      "Fokus pada beasiswa dan jalur masuk kampus di Indonesia, termasuk LIPIA Jakarta.",
    scope: ["Beasiswa dalam negeri", "Jalur masuk kampus", "LIPIA Jakarta"],
    image: indonesiaImage,
    checkoutUrl: "https://goakal.com/pintarpilihkuliah/indonesia/p0tn2/apply",
    coupons: [{ code: "diskon50indonesia", label: "Hemat Rp50.000" }],
  },
  {
    id: "timur-tengah",
    name: "Program Mentoring Beasiswa Timur Tengah",
    shortName: "Timur Tengah",
    description:
      "Siapkan pendaftaran beasiswa untuk negara tujuan di kawasan Timur Tengah.",
    scope: [
      "Mesir",
      "Arab Saudi",
      "Uni Emirat Arab",
      "Qatar",
      "6 negara lainnya",
    ],
    image: middleEastImage,
    checkoutUrl:
      "https://goakal.com/pintarpilihkuliah/timur-tengah/rt9c5/apply",
    coupons: [{ code: "diskon50timteng", label: "Hemat Rp50.000" }],
  },
  {
    id: "eropa",
    name: "Program Mentoring Beasiswa Eropa",
    shortName: "Eropa",
    description:
      "Siapkan pendaftaran beasiswa untuk negara tujuan di kawasan Eropa.",
    scope: ["Jerman", "Turki", "Perancis", "Inggris", "4 negara lainnya"],
    image: europeImage,
    checkoutUrl: "https://goakal.com/pintarpilihkuliah/eropa/8r1n3/apply",
    coupons: [{ code: "diskon50eropa", label: "Hemat Rp50.000" }],
  },
  {
    id: "asia-pasifik",
    name: "Program Mentoring Beasiswa Asia Pasifik",
    shortName: "Asia Pasifik",
    description:
      "Siapkan pendaftaran beasiswa untuk negara tujuan di kawasan Asia Pasifik.",
    scope: ["China", "India", "Malaysia", "Australia", "6 negara lainnya"],
    image: asiaPacificImage,
    checkoutUrl:
      "https://goakal.com/pintarpilihkuliah/asia-pasifik/a4c0v/apply",
    coupons: [{ code: "diskon50asia", label: "Hemat Rp50.000" }],
  },
];

export const mentoringPrograms = [allRegionsProgram, ...regionalPrograms];
